module.exports = __webpack_public_path__ + "fonts/RenaultLife-Italic.woff";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/fonts/latin-basic/RenaultLife-Italic.woff
// module id = 356
// module chunks = 0